import React, { Component } from 'react'
import { AlphanumericInputWithMask, FieldGroup } from '@lmig/lmds-react'

class City extends Component {
  state = {
    ht: 'error',
    val: undefined,
  }
  handleFormChange = event => {
    let inputValue = event.target.value
    if (inputValue.length > 0) {
      this.setState({ ht: undefined })
    } else {
      this.setState({ ht: 'error' })
    }
  }
  render() {
    const { onChangeValue } = this.props
    const regex = /^[^*|":<>[\]{}`\\;@$%!]+$/
    return (
      <FieldGroup
        id='fieldgroup--city'
        disableMargins='top'
        messages={[
          {
            text: 'Required',
            type: 'error',
          },
        ]}
      >
        <AlphanumericInputWithMask
          name='city'
          highlightType={this.state.ht}
          id='Alphanumeric--city'
          labelVisual='City'
          mask={{mask: regex}}
          onChange={function (e) {
            onChangeValue(e)
            this.handleFormChange(e)
          }.bind(this)}
        />
      </FieldGroup>
    )
  }
}

export default City
